import React from "react";
import { useCurrentUser } from "APP_ROOT/hooks";
import { Select } from "MODULES/shared/components/Forms";
import { Field } from "redux-form";
import { arrayToProperCasedOptionsWithCurrentValue } from "LIB/forms";
import { TOOLING_PART_TYPE, TOOLING_PART_TYPES } from "MODULES/parts/constants";
import { withFieldAccessors } from "MODULES/shared/decorators/withFieldAccessors";

function PartTypes({ getInitialFieldValue }) {
  const currentUser = useCurrentUser();
  const partTypes = currentUser.tenant.part_types || TOOLING_PART_TYPES;
  const initialValue = getInitialFieldValue
    ? getInitialFieldValue(TOOLING_PART_TYPE)
    : null;

  return (
    <Field
      name={TOOLING_PART_TYPE}
      component={Select}
      label="Part Type"
      options={arrayToProperCasedOptionsWithCurrentValue(
        partTypes,
        initialValue
      )}
    />
  );
}

export default withFieldAccessors(PartTypes);



// WEBPACK FOOTER //
// ./app/modules/shared/components/PartTypes/PartTypes.jsx